import { DateTime } from 'luxon';

export function formatDateTime(date: Date, format: string, culture: string) {
  return DateTime.fromJSDate(date).setLocale(culture).toFormat(format);
}
